import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView, ListSection, ListItem } from 'medua-components';

/* eslint-disable */
@translate('account')
export default class AccountHelp extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:help.title') }>
        <ListSection margin padding>
          <ListItem
            title={ this.props.t('account:help.faq') }
            handleClick={ () => window.open('https://medua.freshdesk.com/', '_blank') } />
          <ListItem
            title={ this.props.t('account:help.chat') }
            handleClick={ () => window.fcWidget.open() } />
        </ListSection>
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/help/index.jsx